# LOG OUT, ONCE — every Log Out button in the shells comes through here.
#
# Two cards, one handler, and it used to be copied into five places (the parent
# and lockdown title bars, the teacher and organization title bars, and the
# subscription-ended screen):
#
# - THE REVOKE IS WAITED FOR — card 6abd7b187009a562af2600c4. Each copy called
#   loopbackAPI.logout() and set window.location on the same tick. The revoke
#   is an HTTP call axios sends a few milliseconds later, so the navigation
#   started first and cancelled it: elfeet QA 2026-09-30, navigation at
#   20:41:20.791Z, GET /api/LoginsLogout at .796Z, no response. When the
#   revoke never left the browser the logged-out token stayed live. The
#   framework's logout() now returns a promise that settles when the revoke has
#   answered (bounded, so a dead server never holds anyone on the page), and
#   nothing here leaves until it has.
#
# - THE APP LANDS ON SIGN-IN — card 6abdccb77009a562af260132, owner 2026-09-30
#   MT: "Web Log Out stays as it is: it lands on the home page. Only the app
#   changes: app Log Out goes to the login page." Android keeps its bundled
#   start page; the other apps (the iOS bridge) went to "/", the marketing home
#   page, and now go to /app — no fragment, so it is a full page load and not a
#   hash change inside the old session's page, and the empty route is the
#   'login' state.

export WEB_LOG_OUT_DESTINATION = "/"
export APP_LOG_OUT_DESTINATION = "/app"
export ANDROID_LOG_OUT_DESTINATION = "file:///android_asset/www/index.html"

export logOutDestination = (app = window.app) ->
  return WEB_LOG_OUT_DESTINATION unless app?.isApp?()
  return ANDROID_LOG_OUT_DESTINATION if app.isAndroid?()
  APP_LOG_OUT_DESTINATION

# Sign out, wait for the revoke, then run `next` — for the one caller that does
# not leave the page (student mode hands the device back to the parent).
export logOutThen = (next) ->
  Promise.resolve(window.app.loopbackAPI.logout()).then -> next()

# Sign out, wait for the revoke, then leave for this platform's destination.
export logOutAndLeave = ->
  logOutThen -> window.location = logOutDestination()
